import React from "react";
import { Box } from "@mui/material";
import PurchaseInvoiceTable from "./PurchaseInvoiceTable.jsx";

const PurchaseInvoice = ({ hideMainTitle = false }) => {
  return (
    <Box>
      <PurchaseInvoiceTable hideMainTitle={hideMainTitle} />
    </Box>
  );
};

export default PurchaseInvoice;
